<div class="container">
    <!-- <button class="button">Save My Apps</button> -->
    <div class="text-content">
        
        <mat-card-actions>
          <button class="form_button" routerLink="/ude-admin" mat-raised-button color="primary"><mat-icon>arrow_back_2</mat-icon> Back</button>
        </mat-card-actions>
    </div>
</div>
<div class="super-admin">
    <!-- <div class="heading">Category</div> -->
    <div class="admin-form">
        <form [formGroup]="adminForm">
          <div class="expand-form-group"> 
            <div class="col2">
                <mat-label >Brand:</mat-label>
                <mat-radio-group aria-label="Select brand" class="radio-container"
                    formControlName="brand" (change)="fetchAllCategories()"> 
                    @for (data of brand; track data.option) {
                    <mat-radio-button class="example-radio-button" [value]="data.option">{{data.type}}</mat-radio-button>
                    }
                </mat-radio-group>
                <mat-error *ngIf="!f['brand'].valid && f['brand'].touched">
                    This is required field.
                </mat-error> 
            </div>
            <div class="col2">
                <mat-label>Country:</mat-label>
                <mat-radio-group aria-label="Select brand" class="radio-container"
                formControlName="country"  (change)="fetchAllCategories()">
                @for (data of country; track data.option) {
                    <mat-radio-button class="example-radio-button" [value]="data.option">{{data.type}}</mat-radio-button>
                }
                <mat-error *ngIf="!f['country'].valid && f['country'].touched">
                    This is required field.
                </mat-error> 
                </mat-radio-group>

            </div>
        </div>
          <div class="div-container">
              <div class="source-div"> 
                <mat-form-field class="form-field-width-big" appearance="outline">
                    <mat-label for="category">Source Category</mat-label>
                    <mat-select formControlName="source_category_id" matInput (selectionChange)="onSourceCategoryChange($event)" >
                        <mat-option value="">Select Category</mat-option>
                        <mat-option *ngFor="let data of allCategories" [value]="data._id">
                            {{data.category_en}}<!-- -{{data._id}} -->
                          </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <!-- <mat-dialog-actions class="pre">
            </mat-dialog-actions> -->
            <div class="destination-div">
              <mat-form-field class="form-field-width-big" appearance="outline">
                  <mat-label for="category">Target Category</mat-label>
                  <mat-select formControlName="destination_category_id" matInput (selectionChange)="onDestinationCategoryChange($event)">
                      <mat-option value="">Select Category</mat-option>
                      <mat-option *ngFor="let data of allCategories" [value]="data._id">
                          {{data.category_en}}<!-- -{{data._id}} -->
                        </mat-option>
                  </mat-select>
              </mat-form-field>
          </div>
        </div>
          <div class="div-container">
              <div>
                <mat-label class="type">Source Links</mat-label>
                <mat-selection-list class="multi-select" #cell1 formControlName="sourceLinks" (selectionChange)="onSourceLinksChange($event)" > <!-- (click)="onSelectList($event,'left')"-->
                  <mat-list-option [value]="link" *ngFor="let link of sourceLinks">
                    {{link.title_en}} <span class="active_cls"> {{link.active ? 'Active' : 'Inactive'}}</span><!-- -<span class="tiny-txt">{{link._id}}</span> -->
                    &nbsp;
                    <span  class="new-cls">{{link.new}}</span>
                  </mat-list-option>
                </mat-selection-list>
              </div>
          
              <mat-dialog-actions class="pre">
                <button align="start" mat-button  [disabled]="sourceLinks.length === 0 || !adminForm.controls['destination_category_id'].value" 
                  cdkFocusInitial (click)="moveToTarget()"  >
                  <mat-icon>arrow_forward_2</mat-icon>

                </button>
                <button align="start" mat-button  [disabled]="destinationLinks.length ===0 ||  !adminForm.controls['source_category_id'].value "
                cdkFocusInitial  (click)="moveToSource()">
                <mat-icon>arrow_back_2</mat-icon>

                </button>
                <div class="clear-btn">
                <button class="button-submit" mat-button cdkFocusInitial (click)="ngOnInit()"  >
                    Clear
                  </button>
                </div>
                </mat-dialog-actions>
              <div>
                <mat-label class="claim">Target Links</mat-label>
                <mat-selection-list  class="multi-select" #cell2 formControlName="destinationLinks" (selectionChange)="onDestinationLinksChange($event)" > <!-- (click)="onSelectList($event,'right')"-->
                 <mat-list-option [value]="link" *ngFor="let link of destinationLinks">
                    {{link.title_en}} <span class="active_cls">{{link.active ? 'Active' : 'Inactive'}}</span><!-- -<span class="tiny-txt">{{link._id}}</span> -->
                    &nbsp;
                    <span  class="new-cls">{{link.new}}</span>
                </mat-list-option>
                </mat-selection-list>
              </div>
          </div>
        </form>
    </div>
    <div class="save-btn">
        <button class="form_button" mat-raised-button color="primary" (click)="save()"><mat-icon>save</mat-icon>Save</button>
    </div>
</div>


